import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, TimePicker, Select, Tag, Space, Typography } from 'antd';
import { MailOutlined, ClockCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
// import './AlertModule.css';

const { Text } = Typography;

const AlertEditModal = ({ visible, alert, onOk, onCancel, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (alert && visible) {
      form.setFieldsValue({
        recipients: alert.recipients || [],
        scheduledDate: alert.scheduledDate ? dayjs(alert.scheduledDate) : null,
        scheduledTime: alert.scheduledTime ? dayjs(alert.scheduledTime, 'HH:mm') : null,
      });
    }
  }, [alert, visible, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const updateData = {
        recipients: values.recipients || [],
        scheduledDate: values.scheduledDate ? values.scheduledDate.format('YYYY-MM-DD') : null,
        scheduledTime: values.scheduledTime ? values.scheduledTime.format('HH:mm') : null,
      };
      onOk(alert.id, updateData);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const getAlertTypeTag = (type) => {
    const typeConfig = {
      expiry: { color: 'orange', label: 'Expiry Alert' },
      sync: { color: 'red', label: 'Sync Issue' },
      po: { color: 'blue', label: 'Purchase Order' },
      so: { color: 'green', label: 'Sales Order' },
    };
    const config = typeConfig[type] || { color: 'default', label: type };
    return <Tag color={config.color}>{config.label}</Tag>;
  };

  return (
    <Modal
      title={
        <Space>
          <span>Configure Alert Notification</span>
          {alert && getAlertTypeTag(alert.type)}
        </Space>
      }
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Save & Schedule"
      cancelText="Cancel"
      width={560}
      className="alert-edit-modal"
      destroyOnClose
    >
      {alert && (
        <div className="alert-details-section">
          <Text strong>{alert.title}</Text>
          <Text type="secondary" className="alert-description">{alert.description}</Text>
        </div>
      )}

      <Form
        form={form}
        layout="vertical"
        className="alert-form"
      >
        <Form.Item
          name="recipients"
          label={
            <Space>
              <MailOutlined />
              <span>Email Recipients</span>
            </Space>
          }
          rules={[
            { required: true, message: 'Please add at least one recipient' },
          ]}
        >
          <Select
            mode="tags"
            placeholder="Enter email addresses"
            tokenSeparators={[',', ' ']}
            style={{ width: '100%' }}
            options={[
              { value: 'warehouse@company.com', label: 'warehouse@company.com' },
              { value: 'procurement@company.com', label: 'procurement@company.com' },
              { value: 'sales@company.com', label: 'sales@company.com' },
              { value: 'logistics@company.com', label: 'logistics@company.com' },
              { value: 'manager@company.com', label: 'manager@company.com' },
            ]}
          />
        </Form.Item>

        <div className="schedule-row">
          <Form.Item
            name="scheduledDate"
            label={
              <Space>
                <CalendarOutlined />
                <span>Schedule Date</span>
              </Space>
            }
            rules={[{ required: true, message: 'Please select a date' }]}
            className="schedule-field"
          >
            <DatePicker 
              style={{ width: '100%' }} 
              disabledDate={(current) => current && current < dayjs().startOf('day')}
              format="YYYY-MM-DD"
            />
          </Form.Item>

          <Form.Item
            name="scheduledTime"
            label={
              <Space>
                <ClockCircleOutlined />
                <span>Schedule Time</span>
              </Space>
            }
            rules={[{ required: true, message: 'Please select a time' }]}
            className="schedule-field"
          >
            <TimePicker 
              style={{ width: '100%' }} 
              format="HH:mm"
              minuteStep={15}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AlertEditModal;
